import React, { useEffect, useRef, useState } from "react";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { useHistory } from "react-router-dom";
import "./login.css";
import cws_logo from "../../asserts/images/Landing Page - Middle Placeholder Image (4975x2767px).png";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import axios from "../../axios-order";
import { toast } from "react-toastify";

import Modal from "react-bootstrap/Modal";
import CircularProgress from "@material-ui/core/CircularProgress";

import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import ReCAPTCHA from "react-google-recaptcha";
import { v4 as uuidv4 } from 'uuid';


function MyVerticallyCenteredModal(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Cappitall Want Solutions (CWS) offers
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h5 style={{ textDecoration: "underline" }}>
          Invoice Discounting & Invoice Collection Services-
        </h5>
        <p style={{ marginTop: "20px", marginBottom: "20px" }}>
          We are a market place for{" "}
          <span style={{ fontWeight: 600 }}>Invoice Discounting</span> and{" "}
          <span style={{ fontWeight: 600 }}>Collection service</span>s and
          assist to reach multiple service providers efficiently to ensure you
          choose the one best suited for your organization. You get to choose
          multiple service providers to help you in optimizing debtors related
          working capital management
        </p>
        <h5 style={{ textDecoration: "underline" }}>
          ARC – Accounting Reconciliation and Compliance
        </h5>
        <p style={{ marginTop: "20px", marginBottom: "20px" }}>
          We provide assistance in ready to upload{" "}
          <span style={{ fontWeight: 600 }}>Accounting entries</span> relating
          to Invoice Discounting and Collection transactions ensuring accuracy
          and efficiency in handling them.
        </p>
        <p style={{ marginTop: "20px", marginBottom: "20px" }}>
          We track the entire receivable cycle including discounting and
          collection services if availed within our platform or outside and
          enhances the visibility of debtors related working capital management
          with access to various dashboards and reporting.
        </p>
        <p>
          We also help in{" "}
          <span style={{ fontWeight: 600 }}>Reconciliation</span> and{" "}
          <span style={{ fontWeight: 600 }}>Compliance</span> of TDS and GST
          related transactions.
        </p>
        <h6
          style={{
            textAlign: "center",
            marginTop: "20px",
            marginBottom: "20px",
          }}
        >
          Want to know how? Reach our customer support!! @
          <a style={{ color: "#000" }} href="mailto:support@cappitallwant.com">
            {" "}
            support@cappitallwant.com
          </a>
        </h6>
        <p style={{ textAlign: "center" }}>
          <span style={{ fontWeight: 600 }}>Coming Soon... </span> Onboarding
          more solution partners for Invoice discounting and collections!!
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}

const MyLoginPage = () => {
  let history = useHistory();
  const [user_email_id, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [Forgotpassword, setForgotpassword] = React.useState(false);
  const [Message, setMessage] = React.useState("");
  const [status, setStatus] = React.useState("");
  const [modalShow, setModalShow] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const [captchaVerified, setCaptchaVerified] = React.useState(false);
  const [otp, setOtp] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [resendDisabled, setResendDisabled] = useState(true);
  const [sendOtpLoading, setSentOtpLoading] = useState(false)
  const [VerifyLoading, setVerifyLoading] = useState(false)
  const [timer, setTimer] = useState(30);
  const recaptchaRef = useRef();

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  // const handleMouseDownPassword = (
  //   event: React.MouseEvent<HTMLButtonElement>
  // ) => {
  //   event.preventDefault();
  // };

  // onchange function for email and password
  const onChangeHandler = (event) => {
    event.preventDefault();
    if (event.target.name === "user_email_id") {
      setUsername(event.target.value);
    } else if (event.target.name === "otp") {
      setOtp(event.target.value)
    } else {
      setPassword(event.target.value);
    }
  };

  const onCaptchaChange = (value) => {
    if (value) {
      setCaptchaVerified(true);
    } else {
      setCaptchaVerified(false);
    }
  };

  useEffect(() => {
    let countdown;
    if (otpSent && resendDisabled) {
      countdown = setInterval(() => {
        setTimer((prev) => {
          if (prev === 1) {
            clearInterval(countdown);
            setResendDisabled(false);
            return 30;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(countdown);
  }, [otpSent, resendDisabled, timer]);

  useEffect(()=>{
    if (captchaVerified){
      if (recaptchaRef.current) {
        console.log("capch reseting................", captchaVerified)
        recaptchaRef.current.reset();
        setCaptchaVerified(false) // Reset ReCAPTCHA widget
      }
    }
  }, [user_email_id])

  const handleSendOtp = () => {
    // Check if CAPTCHA is verified before proceeding
    if (!captchaVerified) {
      toast.error("CAPTCHA verification is required to proceed. Please complete the verification and try again.", { autoClose: 2000 });
      return;
    }
  
    const payLoadData = {
      "email": user_email_id,
      "otp": null
    };
  
    setSentOtpLoading(true);
  
    axios.post("/auth/mfa", payLoadData)
      .then((res) => {
        if (res?.data?.status) {
          setOtpSent(true);
          setResendDisabled(true); // Disable resend button
          setTimer(30);
          toast.success(res?.data?.message, { autoClose: 2500, progress: 0 });
        } else {
          // Handle error: invalid email or server error
          const errorMessage = res?.data?.message || "Invalid email or some error occurred";
          toast.error(errorMessage, { autoClose: 2500, progress: 0 });
  
          // Reset CAPTCHA if email is incorrect
          setCaptchaVerified(false); // Reset CAPTCHA
          if (recaptchaRef.current) {
            recaptchaRef.current.reset(); // Reset CAPTCHA widget
          }
        }
      })
      .catch((err) => {
        const errorMessage = err?.response?.data?.message || "An error occurred while processing your request. Please try again.";
        toast.error(errorMessage, { autoClose: 2500, progress: 0 });
  
        // Reset CAPTCHA and ReCAPTCHA widget on error
        setCaptchaVerified(false); // Reset CAPTCHA verification state
        if (recaptchaRef.current) {
          recaptchaRef.current.reset(); // Reset ReCAPTCHA widget
        }
      })
      .finally(() => {
        setSentOtpLoading(false);
      });
  };
  

  const handleVerifyOtp = () => {
    const sessionId = uuidv4();
    const payLoadData = {
      "email": user_email_id,
      "otp": otp,
      "session_id" : sessionId
    };
    
    setVerifyLoading(true);
  
    axios.post("/auth/mfa", payLoadData)
      .then((res) => {
        if (res?.data?.status) {
          const session_id = res?.data?.session_id
          if (otp && session_id && session_id !== sessionId){
            toast.error("Invalid or expired OTP. Please try again.", { autoClose: 2500, progress: 0 });
            return
          }
          setOtpVerified(true);
          toast.success(res?.data?.message, { autoClose: 2500, progress: 0 });
        } else {
          toast.error(res?.data?.message, { autoClose: 2500, progress: 0 });
  
          // Reset CAPTCHA if OTP is incorrect
          setCaptchaVerified(false); // Reset CAPTCHA
          if (recaptchaRef.current) {
            recaptchaRef.current.reset(); // Reset CAPTCHA widget
          }
        }
      })
      .catch((err) => {
        toast.error("Server error, please try again later.", { autoClose: 2500, progress: 0 });
  
        // Reset CAPTCHA and ReCAPTCHA widget on error
        setCaptchaVerified(false); // Reset CAPTCHA verification state
        if (recaptchaRef.current) {
          recaptchaRef.current.reset(); // Reset ReCAPTCHA widget
        }
      })
      .finally(() => {
        setVerifyLoading(false);
      });
  };
  
  // onSubmit function
  let trigger = 1;
  const submitHandler = () => {
    if (!captchaVerified) {
      toast.error("CAPTCHA verification is required to proceed. Please complete the verification and try again.", { autoClose: 2000 });
      return;
    }
    setLoading(true);

    if (Forgotpassword) {
      axios
        .post("/forgot_password", { user_email_id })
        .then((res) => {
          setStatus(res.data.status);
          setMessage(res.data.message);
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message, { autoClose: 2000 });
        });
    } else {
      axios
        .post("/login", { user_email_id, password })
        .then((res) => {
          setLoading(false);
          trigger = 1;
          const user_token = res.data.token;
          const user_role = res.data.user_role;
          const user_id = res.data.id;
          const user_name = res.data.user_name;
          localStorage.setItem("token", user_token);
          localStorage.setItem("role", user_role);
          localStorage.setItem("user_id", user_id);
          localStorage.setItem("user_name", user_name);

          history.push("/home");
        })
        .catch((error) => {
          if (error.response !== undefined) {
            trigger += 1;
            if (trigger < 1) {
              submitHandler();
            } else {
              setLoading(false);
              trigger = 1;
              toast.error(error?.response?.data?.message, { autoClose: 2000 });
            }
          } else {
            trigger += 1;
            if (trigger < 1) {
              submitHandler();
            } else {
              setLoading(false);
              trigger = 1;
              toast.error("Server Error Try After Some Time.", {
                autoClose: 2000,
              });
            }
          }
        });
    }
  };

  // route function for registation page
  const toRegistationPage = () => {
    history.push("/Registration");
  };

  const fogotPasswordHandler = () => {
    setForgotpassword(true);
  };

  const justLogin = () => {
    setForgotpassword(false);
    setStatus("");
    setMessage("");
    setUsername("");
  };

  return (
    <div id="Login-section">
      <Container>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={5}>
            <div className="login-form-section">
              <div>
                <img className="loginLogo" src={cws_logo} alt="cappitallwant" />
              </div>

              {Forgotpassword ? (
                ""
              ) : (
                <div className="login-form-title">
                  <center>Login here!</center>
                </div>
              )}
              {Forgotpassword ? (
                <div>
                  <center style={{ fontSize: "24px" }}>
                    Reset your password
                  </center>
                  <center style={{ fontSize: "14px" }}>
                    Enter your user account's verified email address and we will
                    send you a temporary password.
                  </center>
                </div>
              ) : (
                ""
              )}

              <div className="login-form-body">
                <ValidatorForm
                  onSubmit={submitHandler}
                  onError={(errors) => console.log(errors)}
                >
                  <TextValidator
                    margin="dense"
                    fullWidth={true}
                    label="Email Id"
                    name="user_email_id"
                    value={user_email_id}
                    variant="outlined"
                    size="small"
                    validators={["required"]}
                    errorMessages={["Please enter the Email id."]}
                    onChange={onChangeHandler}
                    disabled={otpVerified}
                    inputProps={{ maxLength: 100 }}
                  />
                  {(user_email_id && !otpSent) && (
                    <div style={{ minHeight: "40px", width: "100%", marginTop: "10px", display: "flex", alignItems: "center" }}>
                      <ReCAPTCHA
                        ref={recaptchaRef}
                        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                        onChange={onCaptchaChange}
                        size="normal"
                        style={{
                          transform: "scale(0.88)",
                          transformOrigin: "0 0",


                        }}
                      />
                    </div>
                  )}

                  {(!Forgotpassword && !otpSent) && (
                    <Button
                      fullWidth
                      // color="primary"
                      variant="contained"
                      style={{ marginTop: "15px", marginBottom: '8px', backgroundColor:'var(--app-bar-bg)', color:'#FFFFFF'}}
                      onClick={handleSendOtp}
                      disabled={sendOtpLoading || !user_email_id}
                    >
                      {
                        sendOtpLoading ?
                          <>
                            <CircularProgress
                              size={22}
                              style={{ color: "white" }}
                            />{" "}
                            <span style={{ paddingLeft: "5px" }}></span>
                          </>
                          :
                          "Send OTP"
                      }
                    </Button>
                  )}

                  {(!Forgotpassword && otpSent && !otpVerified) && (
                    <>
                      <TextValidator
                        margin="dense"
                        fullWidth={true}
                        label="Enter OTP"
                        name="otp"
                        value={otp}
                        variant="outlined"
                        size="small"
                        onChange={onChangeHandler}
                      />
                      <Button
                        fullWidth
                        // color="primary"
                        variant="contained"
                        onClick={handleVerifyOtp}
                        style={{ marginTop: "15px", marginBottom: '5px', backgroundColor:'var(--app-bar-bg)', color:'#FFFFFF'}}
                        disabled={VerifyLoading || !otp}
                      >
                        {
                          VerifyLoading ?
                            <>
                              <CircularProgress
                                size={22}
                                style={{ color: "white" }}
                              />{" "}
                              <span style={{ paddingLeft: "5px" }}></span>
                            </>
                            :
                            "Verify OTP"
                        }
                      </Button>
                      <Button
                        fullWidth
                        variant="outlined"
                        onClick={handleSendOtp}
                        style={{ marginTop: "15px", marginBottom: '8px', borderColor:'var(--app-bar-bg)', color:'var(--app-bar-bg)'}}
                        disabled={resendDisabled || VerifyLoading}
                      >
                        {
                          resendDisabled
                            ?
                            `Resend OTP in ${timer}s`
                            : (
                              sendOtpLoading ?
                                <>
                                  <CircularProgress
                                    size={22}
                                    style={{ color: "blue" }}
                                  />{" "}
                                  <span style={{ paddingLeft: "5px" }}></span>
                                </>
                                : "Resend OTP"
                            )}
                      </Button>
                    </>
                  )}

                  {Forgotpassword ? (
                    ""
                  ) : (
                    (otpVerified && <TextValidator
                      margin="dense"
                      fullWidth={true}
                      label="Password"
                      name="password"
                      variant="outlined"
                      size="small"
                      type={showPassword ? "text" : "password"}
                      value={password}
                      validators={["required"]}
                      errorMessages={["Please enter the password."]}
                      onChange={onChangeHandler}
                      // icon for show password

                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              // onMouseDown={handleMouseDownPassword}
                              edge="end"
                            >
                              {showPassword ? (
                                <VisibilityOff size="small" />
                              ) : (
                                <Visibility size="small" />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}

                    />)
                  )}




                  {(Forgotpassword || otpVerified) &&
                    <Button
                      style={{
                        marginTop: "15px",
                        fontFamily: "Dosis",
                        fontSize: "16px",
                        fontWeight: "550",
                        backgroundColor:'var(--app-bar-bg)',
                        color:'#FFFFFF'
                      }}
                      type="submit"
                      margin="dense"
                      variant="contained"
                      fullWidth={true}
                      // color="primary"
                      disabled={loading}
                    >
                      {Forgotpassword ? (
                        "Reset Password"
                      ) : loading ? (
                        <>
                          <CircularProgress
                            size={22}
                            style={{ color: "white" }}
                          />{" "}
                          <span style={{ paddingLeft: "5px" }}></span>
                        </>
                      ) : (
                        "Login"
                      )}
                    </Button>
                  }
                  {/* {Message?<DoneIcon style={{color:"green"}}/>:""} */}
                  {status ? (
                    <center style={{ color: "green" }}>{Message}</center>
                  ) : (
                    <center style={{ color: "red" }}>{Message}</center>
                  )}

                  <p className="RegisterLink">
                    Don't have an account yet?{" "}
                    <span
                      className="RegisterLinkSpan"
                      onClick={toRegistationPage}
                    >
                      Register
                    </span>
                  </p>
                  <div className="forgot-password">
                    {Forgotpassword ? (
                      <span style={{ cursor: "pointer" }} onClick={justLogin}>
                        Just Login
                      </span>
                    ) : (
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={fogotPasswordHandler}
                      >
                        Forgot Password?
                      </span>
                    )}
                  </div>
                  <div className="know-more">
                    <a href="https://www.cappitallwant.com/" target="_blank ">
                      Know more
                    </a>
                  </div>
                </ValidatorForm>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={7}></Grid>
        </Grid>

        <MyVerticallyCenteredModal
          show={modalShow}
          onHide={() => setModalShow(false)}
        />
      </Container>
    </div>
  );
};

export default MyLoginPage;
